<template>
  <div class="bankPrivacyJson">
    <div style="line-height:25px;" v-html="bankPrivacy">
      {{ bankPrivacy }}
    </div>
  </div>
</template>
<script>
import service from "../../../api/bank/index";

export default {
  data() {
    return {
      bankPrivacy: '',
      htmlJson:''
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      service.getMini('111111111111123').then((res) => {
        this.bankPrivacy =res.data.htmlJson;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.bankPrivacyJson {
  padding: 15px;
  // letter-spacing: 1px;
  background: #fff;
}
</style>